<template>
  <div class="loginOn">
    <div class="goback"
    ><img style="" src="../../../static/img/login/logo_icon@2x.png" alt="" />
    </div>
    <div class="loginTitle"> 欢迎登录家庭中医馆 </div>
    <div v-show="passwordLogin">
      <div class="loginInp">
        <input
          class="uni-input"
          placeholder="请输入账号或者手机号"
          :type="phoneType"
          v-model="phoneNumber"
          style="outline: none"
        />
        <input
          class="uni-input iconImg"
          :type="passwordType"
          placeholder="请输入密码"
          v-model="password"
          style="outline: none"
        />
        <img
          v-show="okNo"
          @click="shouHide"
          src="../../../static/img/login/icon_不可见.png"
          alt=""
        />
        <img
          v-show="!okNo"
          @click="shouHide"
          src="../../../static/img/login/icon_可见.png"
          alt=""
        />
        <img
          style="position: absolute; right: 5rem; top: 3.4375rem"
          v-show="pwdErr"
          @click="shouHide"
          src="../../../static/img/login/icon_清除.png"
          alt=""
        />
      </div>
      <div style="color: red; padding-left: 2.8125rem" v-show="pwdErrs"
      >账号或密码错误,请重新输入</div
      >
      <div class="agreement">
        已阅读并同意<a style="color: #ac4b38" @click="clickProtocol"
      >《用户注册协议》</a
      >
      </div>
      <div class="loginBtn">
        <button @click="login">登录</button>
      </div>
    </div>
    <div v-show="!passwordLogin">
      <div class="verinput">
        <input
          class="uni-input"
          confirm-type="search"
          placeholder="请输入账号或者手机号"
          :type="phoneType"
          v-model="verPhone"
        />
        <img src="../../../static/img/login/icon_清除.png" alt="" />
      </div>
      <div class="verText"> 未注册的手机号验证后自动创建账号 </div>
      <div class="veragreement">
        已阅读并同意<a style="color: #ac4b38" @click="clickProtocol"
      >《用户注册协议》</a
      >
      </div>
      <div class="verloginBtn">
        <button @click="goto">获取验证码</button>
      </div>
    </div>
    <div class="loginarea">
      <a v-show="passwordLogin" style="color: #ac4b38" @click="verification"
      >验证码登录</a
      >
      <a v-show="!passwordLogin" style="color: #ac4b38" @click="verification"
      >密码登录</a
      >
      <a href="#" @click="findPassword">找回密码</a>
    </div>
    <div class="otherLogin">
      <span
        style="
          display: inline-block;
          flex: 1;
          border-top: 0.0625rem solid #cccccc;
          margin-top: 1.125rem;
        "
      ></span>
      <span
        style="margin-left: 0.3125rem; margin-right: 0.3125rem; color: #aaaaaa"
      >其他登录方式</span
      >
      <span
        style="
          display: inline-block;
          flex: 1;
          border-top: 0.0625rem solid #cccccc;
          margin-top: 1.125rem;
        "
      ></span>
    </div>
<!--    <div class="sanfangLogin">-->
<!--      <img-->
<!--        @click="wechart"-->
<!--        src="../../../static/img/login/icon_WeChat_.png"-->
<!--        alt=""-->
<!--      />-->
<!--      <img src="../../../static/img/login/icon_qq_.png" alt="" />-->
<!--    </div>-->
  </div>
</template>

<script>
import http from "../../util/gaeaApiConfig";
import http2 from "../../util/hermerApiConfig";
import VConsole from 'vconsole'
export default {
  data() {
    return {
      pwdErr: false,
      pwdErrs: false,
      phoneNumber: "",
      password: "",
      passwordType: "password",
      phoneType: "",
      okNo: true,
      passwordLogin: true,
      verPhone: "",
      protocol: "",
    };
  },
  mounted () {
    if(window.location.href.indexOf('1247') != -1){
      new VConsole()
    }
  },
  methods: {
    // 用户注册协议
    clickProtocol() {
      getProtocol({ type: "1" }).then((res) => {
        if (res.data.status_code == 200) {
          let url = encodeURIComponent(res.data.data.url); // URL是要跳转的外部地址 作为参数
          // uni.navigateTo({
          //   url: "/pages/protocol/protocol?url=" + url,
          //   // page.json定义的路径 传url 到webdiv界面去接收 实现跳转
          // });
        }
      });
    },
    // 找回密码跳转
    findPassword() {
      this.$router.push({
        path: "/findPassword",
      })
      // uni.navigateTo({
      //   url: "/pages/findPassword/findPassword",
      // });
    },
    //密码是否可见
    shouHide() {
      this.okNo = !this.okNo;
      if (this.passwordType == "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    //是否为验证码登陆
    verification() {
      this.passwordLogin = !this.passwordLogin;
    },
    //获取验证码
    goto() {
      var data = { phone: this.verPhone};
      this.$router.push({
        name:'getVer',
        query:{
          ...this.$route.query,
          ...data
        }
      })
    },
    //登陆
    login() {
      let url = "users/login";
      // http.post(url, data).then(function (res2) {
      http.post(url,{
        phone: this.phoneNumber,
        udid: "2",
        area_code: "86",
        terminal: "h5",
        platform_type: "1",
        login_type: "3",
        password: this.password,
      }).then((res) => {
        if (res.data.status_code == 200) {
          console.log(res.data.data.user_id);
          localStorage.setItem("user_id", res.data.data.user_id);
          localStorage.setItem(
            "refresh_token",
            res.data.data.refresh_token
          );
          localStorage.setItem(
            "token",
            res.data.data.access_token
          );
          this.$router.push({
            path: "/prescriptionlist",
            query:  this.$route.query,
            Confirmtype:  true,
          });
          setTimeout(()=>{
            if (location.href.indexOf("#") == -1) {
              //在当前页面地址加入"#"，使下次不再进入此判断
              location.href = location.href + "#";
              location.reload();
            }
          },1000)
        } else if (res.data.status_code == 10004) {
          this.pwdErrs = true;
        } else if (res.data.status_code == 20007) {
          // 警告弹框
          alert('该用户尚未注册')
        }
      });
    },
    //微信登陆
    wechart() {
      // uni.login({
      //   provider: "weixin",
      //   success: function (loginRes) {
      //     //console.log(loginRes.authResult);
      //     // 获取用户信息
      //     uni.getUserInfo({
      //       provider: "weixin",
      //       success: function (infoRes) {
      //         //console.log("用户昵称为：" + infoRes.userInfo.nickName);
      //       },
      //     });
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.loginOn {
  width: 100%;
  height: 100%;
  display: flex;
  background: #fff;
  flex-direction: column;
  .goback {
    width: 100%;
    height: 12.5rem;
    background: url(../../../static/img/login/beijing@2x.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    img {
      width: 5.75rem;
      height: 5.75rem;
      margin: 9.375rem auto;
    }
  }
  .loginTitle {
    width: 100%;
    height: 3.125rem;
    margin-top: 3.75rem;
    font-size: 1.5rem;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loginInp {
    width: 100%;
    height: 6.5rem;
    flex-direction: column;
    justify-content: center;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    position: relative;
    .uni-input {
      width: 100%;
      height: 2.5rem;
      border: none;
      font-size: 1rem;
      border-bottom: 0.0625rem solid #ccc;
    }
    img {
      position: absolute;
      right: 3rem;
      top: 3.125rem;
    }
  }
  .agreement {
    width: 100%;
    height: 2.5rem;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
  }
  .loginBtn {
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    height: 40px;
    button {
      width: 100%;
      height: 100%;
      border-radius: 0.625rem;
      border: none;
      background: #ac4b38;
      color: #fff;
    }
  }
  .loginarea {
    width: 100%;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    text-align: right;
    margin-top: 0.8em;
    display: flex;
    a {
      flex: 1;
      text-decoration: none;
      border: none;
      display: flex;
      justify-content: left;
      align-items: center;
    }
    a:nth-of-type(3) {
      color: #ac4b38;
      display: flex;
      justify-content: right;
      align-items: center;
    }
  }
  .verinput {
    width: 100%;
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    position: relative;
    margin-top: 2rem;
    .uni-input {
      width: 100%;
      height: 2.5rem;
      border: none;
      font-size: 1rem;
      border-bottom: 0.0625rem solid #ccc;
    }
    img {
      position: absolute;
      right: 3rem;
      top: 1rem;
    }
  }
  .verText {
    width: 100%;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    color: #ccc;
  }
  .veragreement {
    width: 100%;
    height: 2.5rem;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
  }

  .otherLogin {
    width: 100%;
    height: 2.25rem;
    line-height: 2.25rem;
    display: flex;
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
  }
  .verloginBtn {
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    box-sizing: border-box;
    height: 40px;
    button {
      width: 100%;
      height: 100%;
      border-radius: 0.625rem;
      border: none;
      background: #c8633f;
      color: #fff;
    }
  }
  .sanfangLogin {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/order_login.vue